@if (showBanner) {
    <sh-notification
        [title]="title"
        [message]="message"
        [type]="notificationType.Update"
        [closable]="canBeClosed"
        (closeNotification)="onClose()"
    ></sh-notification>
}
